import type { FC, ReactNode } from 'react';
import { useUpdateValidationErrors } from '../../../../../common/update-information/hooks/useUpdateValidationErrors';
import { ValidationWrapper } from '../../../../../common-ui/form-fields/ValidationWrapper';
import type { BookingValidationErrors } from '../../../../../services/update-form/updateBookingReducer';

interface UpdateValidationWrapperProps {
  name: keyof Omit<BookingValidationErrors, 'goods'>;
  renderField: (isValid: boolean) => ReactNode;
}

export const UpdateValidationWrapper: FC<UpdateValidationWrapperProps> = ({ name, ...props }) => {
  const validationError = useUpdateValidationErrors(name);

  return <ValidationWrapper validationError={validationError} {...props} />;
};
